import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { translate } from 'services/i18nService';
import { chatFontSettings } from 'utils/helpers';

import liveTouchImg from '../../../images/mobileNotificationsChat/liveTouchNotif.png';
import liveTouchImgDesktop from '../../../images/mobileNotificationsChat/live-touch-bg.png';

import styles from './ChatNotificationsTypes.css';


const LiveTouchMobileNotification = ({ message, isDesktop, chatSettings }) => {
  const [isFullNotificationVisible, setVisibility] = useState(false);

  const toggleNotificationVisibility = useCallback(() => {
    if (!isDesktop) {
      setVisibility(!isFullNotificationVisible);
    }
  }, [isDesktop, isFullNotificationVisible]);

  return (
    <div
      className={isDesktop ? styles.liveTouchNotifDesktopWrapper : styles.liveTouchNotifWrapper}
      onClick={toggleNotificationVisibility}
    >
      <div className={styles.liveTouchDescription}>
        <img
          alt="live touch"
          className={styles.livetouchImg}
          src={isDesktop ? liveTouchImgDesktop : liveTouchImg}
        />
        <div className={styles.desktopWrapper}>
          <span
            className={styles.liveTouchText}
            style={chatFontSettings(isDesktop, chatSettings)}
          >
            {translate(
              'v2profile.live.touch.notif',
              { 0: message.roomName }
            )}
          </span>
          {isDesktop && (
            <div
              className={styles.liveTouchFullDescription}
              style={chatFontSettings(isDesktop, chatSettings)}
            >
              <div className={styles.liveTouchOption}>
                <strong>
                  {translate('profile.livetouch.poke')}:
                </strong>
                {' 1-4 '}
                {translate('profile.livetouch.tokens')}
              </div>
              <div className={styles.liveTouchOption}>
                <strong>
                  {translate('profile.livetouch.touch')}:
                </strong>
                {' 5-49 '}
                {translate('profile.livetouch.tokens')}
              </div>
              <div className={styles.liveTouchOption}>
                <strong>
                  {translate('profile.livetouch.feel')}:
                </strong>
                {' 50-249 '}
                {translate('profile.livetouch.tokens')}
              </div>
              <div className={styles.liveTouchOption}>
                <strong>
                  {translate('profile.livetouch.fuck')}:
                </strong>
                {' 250+ '}
                {translate('profile.livetouch.tokens')}
              </div>
            </div>
          )}
        </div>
      </div>
      {isFullNotificationVisible && (
        <div
          className={styles.liveTouchFullDescription}
          style={chatFontSettings(isDesktop, chatSettings)}
        >
          <div className={styles.liveTouchOption}>
            <strong>
              {translate('profile.livetouch.poke')}:
            </strong>
            {' 1-4 '}
            {translate('profile.livetouch.tokens')}
          </div>
          <div className={styles.liveTouchOption}>
            <strong>
              {translate('profile.livetouch.touch')}:
            </strong>
            {' 5-49 '}
            {translate('profile.livetouch.tokens')}
          </div>
          <div className={styles.liveTouchOption}>
            <strong>
              {translate('profile.livetouch.feel')}:
            </strong>
            {' 50-249 '}
            {translate('profile.livetouch.tokens')}
          </div>
          <div className={styles.liveTouchOption}>
            <strong>
              {translate('profile.livetouch.fuck')}:
            </strong>
            {' 250+ '}
            {translate('profile.livetouch.tokens')}
          </div>
        </div>
      )}
    </div>
  );
};

LiveTouchMobileNotification.propTypes = {
  chatSettings: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired,
  message: PropTypes.object.isRequired,
};

export default LiveTouchMobileNotification;
